+function($, window, document) {
	'use strict';
	
	var AjaxDialog = function(element, options) {
		this.options = options;
		this.$element = $(element);
		this.clsDialog = this.$element.data('target');
		
		this.initialize();
	};
	
	AjaxDialog.DEFAULTS = {
		messageEnterRequired: 'Error: please enter the required fields.',
		durationHideError: 5000
	};
	
	AjaxDialog.prototype.initialize = function() {
		this.appendContent();
		this.centerDialog();
		this.observeSubmit();
	};
	
	AjaxDialog.prototype.appendContent = function() {
		var title = this.$element.attr('title'),
			content = '';
		
		content += '<div class="modal ' + this.clsDialog.substr(1) + '" role="dialog" tabindex="-1" aria-hidden="false">' +
						'<div class="modal-dialog">' + 
							'<div class="modal-content">' +
								'<div class="modal-header">' + 
									'<button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>' +
									'<h4 class="modal-title">' + title + '</h4>' + 
								'</div>' +
								
								'<div class="modal-body">' +
									'<div class="loading" src="/asset/img/image_loader.png"></div>' +
								'</div>' + 
								
								'<div class="modal-footer">' + 
									'<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>' +
									'<button type="button" class="btn btn-success">Save</button>' + 
								'</div>' +
							'</div>' +
						'</div>' +
					'</div>';
		
		$(document.body).append(content);
	};
	
	AjaxDialog.prototype.observeSubmit = function() {
		var scope = this;
		
		$(this.clsDialog).on('click', '.modal-footer > .btn:last-child', function() {
			var frm = $(scope.clsDialog).find('form');
			
			frm.formValidator();
			
			if (frm.data('sn.formvalidator').isValid()) {
				frm.submit();
			}
			
			return false;
		});
	};
	
	AjaxDialog.prototype.showError = function(error) {
		var modalBody = $(this.clsDialog).find('.modal-body');
		
		modalBody.prepend('<p class="alert alert-error">' + error + '</p>').show();
		
		setTimeout(function() {
			modalBody.find('.alert-error').hide();
		}, this.options.durationHideError);
	};
	
	AjaxDialog.prototype.centerDialog = function() {
		var dlg = $(this.clsDialog).find('.modal-dialog'),
			win = $(window),
			winWidth = win.width(),
			winHeight = win.height();
		
		$(this.clsDialog).on('shown.bs.modal', function (e) {
			var height = dlg.height(),
				width = dlg.width();
			
			dlg.css({'position': 'fixed', 'left': (winWidth - width) / 2, 'top': '50%', 'margin-top': -(height/2), 'margin-bottom':0});
		});
	};
	
	function Plugin(option) {
	    return this.each(function () {
    		var $this   = $(this),
    			data    = $this.data('sn.ajaxDialog'),
    			options = $.extend({}, AjaxDialog.DEFAULTS, typeof option == 'object' && option);
	      
	      if ( ! data) {
	    	  $this.data('sn.ajaxDialog', (data = new AjaxDialog(this, options)));  
	      } 
	      
	      if (typeof option == 'string') {
	    	  data[option]();  
	      } 
	    });
	}
	
	var old = $.fn.Dialog;
	
	$.fn.ajaxDialog = Plugin;
	$.fn.ajaxDialog.Constructor = AjaxDialog;
	
	$.fn.ajaxDialog.noConflict = function () {
	    $.fn.ajaxDialog = old;
	    return this;
	};
}(jQuery, window, document);